import { Injectable, signal } from '@angular/core';
import { PaymentOption } from '@tabify/models/types';

@Injectable({ providedIn: 'root' })
export class PaymentService {

  // internal mutable signal
  private _option = signal<PaymentOption | null>(null);

  // expose a read‑only view
  readonly option = this._option.asReadonly();

  /** set a new option */
  select(opt: PaymentOption) {
    this._option.set(opt);
  }

  /** clear the selection */
  reset() {
    this._option.set(null);
  }
}
